import { createSelector } from 'reselect'
import { POST_SOCIAL_STATUS, POST_STATUS } from '../models/post'
import { RootState } from '../store'
import { TPost } from '../store/managePost/types'

const notApprovedPostsSelector = (state: RootState) => state.project.currentProject.postsToApproval
const approvedPostsSelector = (state: RootState) => state.project.currentProject.approvedPosts
const managePostState = (state: RootState) => state.managePost

export const selectNotApprovedPostsWithoutRequireRevision = createSelector(
  notApprovedPostsSelector,
  (postsToApproval) =>
    postsToApproval
      .filter(
        (post) =>
          post.status !== POST_STATUS.STATUS_REQUIRES_REVISION ||
          post.post_socials.some(
            (postSocial) => postSocial.status !== POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION
          )
      )
      .map((post) =>
        post.status !== POST_STATUS.STATUS_REQUIRES_REVISION
          ? post
          : {
              ...post,
              post_socials: [...post.post_socials].sort((socialPost) =>
                socialPost.status !== POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION ? -1 : 1
              )
            }
      )
)


export const selectApprovedPosts = createSelector(
  approvedPostsSelector,
  (approvedPosts) =>
  approvedPosts
      .filter(
        (post) =>
          post.status !== POST_STATUS.STATUS_REQUIRES_REVISION ||
          post.post_socials.some(
            (postSocial) => postSocial.status !== POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION
          )
      )
      .map((post) =>
        post.status !== POST_STATUS.STATUS_REQUIRES_REVISION
          ? post
          : {
              ...post,
              post_socials: [...post.post_socials].sort((socialPost) =>
                socialPost.status !== POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION ? -1 : 1
              )
            }
      )
)

export const getPostFromMamagePost = createSelector(managePostState, (managePostData) => {
  let post: TPost = {
    ...managePostData.post,
    latest_schedule: managePostData.latestSchedule,
    media_replication_status: null,
    post_socials: managePostData.postSocials.map((postSocial) => ({
      ...postSocial,
      attachments: postSocial.attachments.filter((attachment) => !attachment.toRemove)
    }))
  }
  return post
})
